module.exports = __webpack_public_path__ + "static/media/21930025-t4O5RSgs.76d4327e.jpeg";